<template>
  <main-layout>
    <div slot="left-side">
      <menubar screenIdParam="M-06-40"></menubar>
    </div>

    <el-row slot="header">
      <headTitle class="cancel-width">
        <label slot="title">
          {{ $t("label.system.userGroup.search.title") }}
        </label>

        <lvory-but
          @click="deleteUserGroup()"
          slot="cancel"
          v-show="this.$IsShowButFun('010704', result.deleteFlag, true) "
        >
          {{ $t("button.common.data.delete") }}
        </lvory-but>
        <narrow-down
          v-show="this.$IsShowButFun('010703', result.deleteFlag, true) "
          @click="goEdit()"
          slot="create"
        >
          {{ $t("button.common.data.edit") }}
        </narrow-down>
      </headTitle>
    </el-row>

    <div slot="body">
      <!-- subtitle -->
      <div class="main-title">
        {{ $t("label.system.userGroup.detail.userGroupDetail") }}
      </div>
      <div>
        <el-form label-width="272px" label-position="left">
          <el-row class="moddleleft">
              <!-- ユーザーグループID -->
              <div class="area-info-type">
                <el-form-item
                  :label="$t('label.system.userGroup.search.userGroupID')">
                  <div class="area-type">
                    <span class="span-wrap-size-color text-word-break">
                        {{ result.userGroupExId }}
                    </span>
                  </div>
                </el-form-item>
                <sp-smart-button style="margin-left: 84px; width: 256px"
                    v-show="this.$IsShowButFun('010704', result.deleteFlag, true) "
                    @click="areaAdd">
                    {{ $t("label.system.userGroup.detail.areaAdd") }}
                </sp-smart-button>
              </div>

              <!-- ユーザーグループ名 -->
              <el-form-item
                :label="$t('label.system.userGroup.search.userGroupName')">
                <span class="span-wrap-size-color text-word-break">
                  {{ result.userGroupName }}
                </span>
              </el-form-item>

              <!-- テナントID -->
              <el-form-item
                :label="$t('label.system.userGroup.detail.tenantId')">
                <span class="span-wrap-size-color text-word-break">
                  {{ result.tenantExId }}
                </span>
              </el-form-item>

              <!-- テナント名 -->
              <el-form-item
                :label="$t('label.system.userGroup.detail.tenantName')">
                <span class="span-wrap-size-color text-word-break">
                  {{ result.tenantName }}
                </span>
              </el-form-item>

              <!--  エリア情報  -->
              <div class="area-info-type">
                <el-form-item
                  :label="$t('label.system.userGroup.detail.areaInfo')">
                  <div  v-for="(item,index) in result.areaList" :key="index" class="span-wrap-size-color text-word-break">
                    {{ item.buildingName + ' ' + item.floorName + ' ' + item.areaName }}
                  </div>
                </el-form-item>
              </div>
          </el-row>
        </el-form>
      </div>

      <hr class="delimiter margin-top-0" />

      <div class="memberInfo-title">
        {{ $t("label.system.userGroup.detail.memberInfo") }}
      </div>

      <el-table
        class="m-top-5 table-header-th-top-0"
        style="width: 100% !important"
        header-cell-class-name="sp-table-cell"
        :data="result.accountList">
        <!--  メンバー名  -->
        <el-table-column
          class-name="col-2"
          prop="fullname"
          :label="$t('label.system.userGroup.detail.memberName')"/>

        <!--  メールアドレス  -->
        <el-table-column
          class-name="col-8"
          prop="email"
          :label="$t('label.system.userGroup.detail.emailAddress')"/>
      </el-table>


      <loading-dialog :dialogVisible="showLoading" />

      <!-- ユーザーエリア選択 子画面 -->

      <el-dialog-prompt
        :centerDialogVisibleParam.sync="centerDialogVisibleIsShow"
        :msgParam="msgParam"
        @on-isPassParam="isPassParam">
      </el-dialog-prompt>

      <area-search-popup
        :userGroupFlag="true"
        :tenantIdParam="result.tenantId"
        :ownerIdParam="result.ownerId"
        @on-selected="addAreaInfo"
        :visible.sync="areaSearchFlg">
      </area-search-popup>

    </div>
  </main-layout>
</template>

<script>
import LoadingDialog from "@/components/common/loading/LoadingDialog";
import SystemManageApi from "@/api/SystemManageApi";
import headTitle from "@/components/common/head/head";
import LvoryBut from "@/components/common/generalButton/LvoryBut";
import NewDesignLayout from "@/layout/NewDesignLayout";
import Menubar from "@/components/leftmenu/DashBoard";
import errorCodeMsg from "@/utils/error-code-msg"
import narrowDown from "@/components/common/generalButton/NarrowDown";
import elDialogPrompt from "@/components/common/el-dialog-prompt"
import statusErrorCodeMsg from "@/utils/status-error-msg"
import SpSmartButton from "@/components/common/sp-smart-button"
import AreaSearchPopup from "@/components/system/popup/AreaSearchPopup";

export default {
  name: "AccountDetail",
  components: {
    MainLayout: NewDesignLayout,
    LoadingDialog: LoadingDialog,
    headTitle,
    LvoryBut,
    Menubar,
    narrowDown,
    elDialogPrompt,
    SpSmartButton,
    AreaSearchPopup
  },
  data() {
    return {
        centerDialogVisibleIsShow:false,
        msgParam:null,
        showLoading:false,
        areaSearchFlg:false,
        userGroupId:null,
        isPassFlag:null,
        result:{
            accountList:[
            ]
        }
    };
  },

  created() {
    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "label.router.comprehensive",
      },
      {
        path: "/system/user-group/search",
        title: "label.menu.UserGroup",
      },
      {
        path: "",
        title: "label.menu.userGroupDetail",
      }
    ]
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb)
    this.userGroupId = this.$route.params.userGroupId;
    this.initializationData()
  },
  mounted() {
  },
  methods: {
    isPassParam(param){
      if(param) {
        if(this.isPassFlag == 'delete') {
          this.showLoading = true
          SystemManageApi.deleteUserGroup(this.userGroupId)
            .catch((error) => {
              errorCodeMsg(error, this)
            })
            .then(({ data }) => {
              if (!statusErrorCodeMsg(data.statusCode, this)) {
                this.showLoading = false
                return;
              }
              this.$router.push({
                name: "system-user-group-search",
              });

              this.deleteSuccess()

            }).finally(()=>{
              this.showLoading = false
            })
        }
      }
    },
    initializationData() {
      this.showLoading = true
      SystemManageApi.detailUserGroup(this.userGroupId)
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({ data }) => {
          if (!statusErrorCodeMsg(data.statusCode, this)) {
            this.showLoading = false
            return;
          }
          this.result = data.body
        }).finally(()=>{
          this.showLoading = false
        })
    },

    goEdit() {
      this.$router.push({
        name: "system-user-group-edit",
        params: {
          userGroupId: this.userGroupId,
        },
      });
    },

    deleteUserGroup() {
      this.isPassFlag = "delete"
      this.centerDialogVisibleIsShow = true
      this.msgParam = this.$t("message.common.validation.deleteMessage",{
        field: this.$t("label.menu.UserGroup")
      })
    },

    areaAdd() {
      this.areaSearchFlg = true
    },

    addAreaInfo(area) {
      this.showLoading = true
      SystemManageApi.userGroupAreaRelations({
        areaId:area.areaId,
        userGroupId:this.userGroupId
      })
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({ data }) => {
          if (!statusErrorCodeMsg(data.statusCode, this)) {
            this.showLoading = false
            return;
          }
          this.initializationData()
        }).finally(()=>{
          this.showLoading = false
        })
    },

    deleteSuccess() {
      this.$messageIotSuccess(this.$t("message.common.deleteSuccess", {
        field: this.$t("label.system.userGroup.search.title"),
      }));
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .cancel-width{
  .my-button{
    width: 152px;
    height: 32px;
  }
}

.hr {
  height: 1px;
  width: 800px;
  background-color: #D1D1CD;
}

.span-wrap-size-color {
  font-size: 16px;
  color: #525250;
}

.area-info-type {
    display: flex;
}

.moddleleft ::v-deep{
  .el-form-item__label {
    font-size: 20px !important;
    line-height: 32px;
  }

  .el-form-item__content {
    line-height: 32px;
  }

  .el-form-item--small.el-form-item{
    margin-bottom: 40px !important;
  }
  .el-form-item {
    margin-bottom: 40px !important;
  }
}

.area-type {
  width: 188px;
}

.memberInfo-title {
  width: 100%;
  line-height: 24px;
  margin-bottom: 40px;
  text-align: left;
  color: #525250;
  font-size: 20px;
}

/* No.129 */
hr.delimiter {
  margin-top:40px;
  margin-bottom: 40px;
  background-color: #d1d1cd;
}

.margin-top-0 {
  margin-top: 0px !important;
}
</style>
